<template>
  <div>
    <img :src="require(`assets/images/onboarding/${illustration}.svg`)"
         class="onboarding__illustration spacer-bottom-l"
    >
    <div class="z-title z-title--small onboarding__title">
      {{ title }}
    </div>
    <p class="z-text" v-html="text"></p>
  </div>
</template>

<style lang="scss" scoped>

.onboarding__illustration {
  display: block;
  height: 160px;
  margin-left: auto;
  margin-right: auto;
  max-width: 100%;

  @media (min-width: $screen-md-min) {
    height: 200px;
  }
}

.onboarding__title {
  margin-bottom: var(--space-medium);

  @media (min-width: $screen-md-min) {
    margin-bottom: var(--space-small);
  }
}
</style>

<script>
export default {
  props: {
    illustration: {
      type: String,
      required: true,
    },
    title: {
      type: String,
      required: true,
    },
    text: {
      type: String,
      required: true,
    },
  },
};
</script>
